import { render, staticRenderFns } from "./LmsErrorScreen.vue?vue&type=template&id=882fb0a4&scoped=true"
import script from "./LmsErrorScreen.vue?vue&type=script&lang=js"
export * from "./LmsErrorScreen.vue?vue&type=script&lang=js"
import style0 from "./LmsErrorScreen.vue?vue&type=style&index=0&id=882fb0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882fb0a4",
  null
  
)

export default component.exports